import { z } from 'zod';

const envSchema = z.object({
  VITE_API_BASE_URL: z.url(),
  VITE_API_VERSION: z.string().min(1),
  VITE_ENABLE_DEV_TOOLS: z.string().optional(),
  VITE_NEW_RELIC_LICENSE_KEY: z.string().optional(),
  VITE_NEW_RELIC_APPLICATION_ID: z.string().optional(),
  VITE_NEW_RELIC_ACCOUNT_ID: z.string().optional(),
  VITE_RELEASE_VERSION: z.string().optional(),
});

type EnvSchema = z.infer<typeof envSchema>;

const validateEnv = (): EnvSchema => {
  try {
    return envSchema.parse(import.meta.env);
  } catch (error) {
    if (error instanceof z.ZodError) {
      const missingVars = error.issues.map((err) => `  - ${err.path.join('.')}: ${err.message}`);
      throw new Error(
        `Environment validation failed:\n${missingVars.join('\n')}\n\nPlease check your .env.local file.`,
      );
    }
    throw error;
  }
};

const env = validateEnv();

export const ENV = {
  apiBaseUrl: env.VITE_API_BASE_URL,
  apiVersion: env.VITE_API_VERSION,
  enableDevTools: env.VITE_ENABLE_DEV_TOOLS === 'true',
  newRelic: {
    licenseKey: env.VITE_NEW_RELIC_LICENSE_KEY,
    applicationId: env.VITE_NEW_RELIC_APPLICATION_ID,
    accountId: env.VITE_NEW_RELIC_ACCOUNT_ID,
  },
  releaseVersion: env.VITE_RELEASE_VERSION,
} as const;
